module.exports = __webpack_public_path__ + "img/15.0484cbbd.jpg";